var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var TipRepository_1;
import { IAPIHTTPDataSourceType, IConfigurationRepositoryType, inject, injectable, Observable } from '@serviceos-rn/core';
import { parseChoiceItems } from '../../Helpers/ParseChoiceItems';
import { TipConfig } from '../../TipConfig';
let TipRepository = TipRepository_1 = class TipRepository {
    constructor(apiDataSource, configurationRepository) {
        this.apiDataSource = apiDataSource;
        this.configurationRepository = configurationRepository;
        this.tip = new Observable();
    }
    setErrorTip(error) {
        return Promise.resolve(this.tip.next({
            type: 'tip',
            customize: {
                status_message: error,
                status: 'error'
            }
        }));
    }
    setTip(tip) {
        this.tip.next(tip);
        return Promise.resolve(this.tip);
    }
    logExceptionMissingTipOptions(tip) {
        return this.apiDataSource.logException({
            path: '',
            body: tip,
            exception: 'No available tip options',
            message: 'No available tip options',
            external_identifier: TipConfig.moduleName
        });
    }
    getTip(bookingId, force) {
        if (this.tip.value && !force) {
            return Promise.resolve(this.tip);
        }
        const data = {
            params: {},
            path: `bookings/${bookingId}/tip_choice`
        };
        return this.apiDataSource.get(data)
            .then((response) => {
            var _a, _b, _c;
            if (!response.data || typeof response.data !== 'object' || Array.isArray(response.data) || Object.keys(response.data).length <= 0) {
                this.apiDataSource.logException({
                    path: data.path,
                    body: data,
                    exception: 'Invalid choice',
                    message: 'Invalid choice',
                    external_identifier: TipConfig.moduleName
                });
                return Promise.reject(new Error(((_c = (_b = (_a = this.configurationRepository.configuration.value) === null || _a === void 0 ? void 0 : _a.application) === null || _b === void 0 ? void 0 : _b.texts) === null || _c === void 0 ? void 0 : _c.error_default_message) || 'Invalid response!'));
            }
            if (!response.data.choice_items || !Array.isArray(response.data.choice_items) || response.data.choice_items.length <= 0) {
                this.apiDataSource.logException({
                    path: data.path,
                    body: data,
                    exception: 'No available tip options',
                    message: 'No available tip options',
                    external_identifier: TipConfig.moduleName
                });
                return Promise.reject(new Error(('No available tip options')));
            }
            this.tip.next(response.data);
            return this.tip;
        });
    }
    sendTip(bookingId, value) {
        const data = {
            params: {},
            data: {
                choice_items: TipRepository_1.parseChoiceItems([value])
            },
            path: `bookings/${bookingId}/tip`
        };
        return this.apiDataSource.post(data)
            .then(response => {
            var _a;
            return {
                type: 'success',
                message: ((_a = response.success) === null || _a === void 0 ? void 0 : _a[0].message) || 'Thank you for tipping'
            };
        })
            .catch(error => {
            return Promise.reject({
                type: 'error',
                message: error.message || error.error[0].message || 'Unsuccessful tipping (Unknown error)'
            });
        });
    }
};
TipRepository.parseChoiceItems = parseChoiceItems;
TipRepository = TipRepository_1 = __decorate([
    injectable({
        type: 'singleton'
    }),
    __param(0, inject(IAPIHTTPDataSourceType)),
    __param(1, inject(IConfigurationRepositoryType)),
    __metadata("design:paramtypes", [Object, Object])
], TipRepository);
export { TipRepository };
